import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { VenderEntity } from '../../domain/entities/VenderEntity'
import type { VenderAdminDto } from '@/backend/market'
export class VenderModel extends VenderEntity {
  constructor(dataDto: VenderAdminDto) {
    super()
    mapEntityProperties<VenderEntity>(this, dataDto)
  }
}
